import React from 'react';
import styled from 'styled-components';
import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {isMobileOnly} from 'react-device-detect';
import moment from "moment";


const EsReqEsInfoBlock = styled.div`
    color: #333333;
    .title {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
        
    }

    .sub-title {
        width: 100px;
        font-size: 13px;
        font-weight: normal;
        line-height: 21px;
        color: #999999;
        float:left;
    }

    .sub-desc {
        font-size: 13px;
        font-weight: normal;
        line-height: 1.69;
        float:left;
    }

    .margin-text {
        margin-bottom: 20px;
        width: 100%;
    }
    
`;

const EsReqEsInfo = ({ esItemDetailInfo, esItem }) => {

    const { es_rqst_id, pckg_nm, rqst_date_format, brnd_han, rqst_price,
        es_dscnt_total_price, es_prdct_total_price, es_final_price,
        expr_date, es_dlvry_total_price, es_detail_dlvry_pay_type, total_qty,
        es_pay_price, dsrd_date_format,es_add_dscnt_price_total, rqst_status, cancel_date_format, rqst_date,es_cancel_date
    } = esItem[0];

    const getRqstDate = () => {
        if(rqst_date !== null  && rqst_date !== undefined){

            return moment(rqst_date).format('YYYY.MM.DD');
        }

        return "";
    }

    const getSendDate = () => {
        if(rqst_status === '050110') {
            if(cancel_date_format !== null && cancel_date_format !== undefined) {
                return moment(es_cancel_date).format('YYYY.MM.DD');
            }
            return "";
        }
        if(esItemDetailInfo !== null && esItemDetailInfo !== undefined){
            if(esItemDetailInfo.masterinfo !== null && esItemDetailInfo.masterinfo !== undefined){

                if(esItemDetailInfo.masterinfo.es_send_date !== null  && esItemDetailInfo.masterinfo.es_send_date !== undefined){

                    return moment(esItemDetailInfo.masterinfo.es_send_date).format('YYYY.MM.DD');
                }
            }
        }

        return "";
    }

    const getExprDate = () => {
        if(rqst_status === '050111') {
            if(cancel_date_format !== null && cancel_date_format !== undefined) {
                return moment(es_cancel_date).format('YYYY.MM.DD');
            }
            return "";
        }
        if(esItemDetailInfo !== null && esItemDetailInfo !== undefined){
            if(esItemDetailInfo.masterinfo !== null && esItemDetailInfo.masterinfo !== undefined){

                if(esItemDetailInfo.masterinfo.expr_date !== null  && esItemDetailInfo.masterinfo.expr_date !== undefined){

                    return moment(esItemDetailInfo.masterinfo.expr_date).format('YYYY.MM.DD');
                }
            }
        }

        return "";
    }

    const getEsDateTitle = () => {
        if(rqst_status === '050108') {
            return "중단일"
        } else if(rqst_status === '050110') {
            return "취소일"
        }
        return "견적일"
    }

    const getEsExprDateTitle = () => {
        if(rqst_status === '050111') {
            return "취소일"
        }
        return "만료일"
    }

    const validEsSendDate = () => {
        if(rqst_status === '050110') {
            return true;
        }

        if(rqst_status === '050102'|| rqst_status === '050104') {
            return false;
        }
        if(esItemDetailInfo !== null && esItemDetailInfo !== undefined){
            if(esItemDetailInfo.masterinfo !== null && esItemDetailInfo.masterinfo !== undefined){

                if(esItemDetailInfo.masterinfo.es_send_date !== null  && esItemDetailInfo.masterinfo.es_send_date !== undefined){

                    return true;
                }
            }
        }

        return false;
    }

    const validExprDate = () => {
        if(rqst_status === '050108' || rqst_status === '050110'|| rqst_status === '050102' || rqst_status === '050104') {
            return false;
        }
        if(rqst_status === '050111') {
            return true;
        }

        if(esItemDetailInfo !== null && esItemDetailInfo !== undefined){
            if(esItemDetailInfo.masterinfo !== null && esItemDetailInfo.masterinfo !== undefined){

                if(esItemDetailInfo.masterinfo.expr_date !== null  && esItemDetailInfo.masterinfo.expr_date !== undefined){

                    return true;
                }
            }
        }

        return false;
    }

    if(esItem === null || esItem === undefined) {
        return <div/>
    }

    if(esItemDetailInfo === null || esItemDetailInfo === undefined) {
        return <div/>
    }

    return (
        <EsReqEsInfoBlock>
            <div className="title margin-text">요청 정보</div>
            <div className="margin-text clearfix">
                <div className="sub-title">견적서 번호</div>
                <div className="sub-desc">No. {es_rqst_id}</div>
            </div>
            <div className="margin-text clearfix">
                <div className="sub-title">견적 요청일</div>
                <div className="sub-desc">{getRqstDate()}</div>
            </div>
            {
                validEsSendDate()&&<div className="margin-text clearfix">
                <div className="sub-title">{getEsDateTitle()}</div>
                <div className="sub-desc">{getSendDate()}</div>
                </div>
            }
            {
                validExprDate()&&<div className="margin-text clearfix">
                <div className="sub-title">{getEsExprDateTitle()}</div>
                <div className="sub-desc">{getExprDate()}</div>
            </div>
            }
            
        </EsReqEsInfoBlock>
    );
};

export default EsReqEsInfo;
